exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".cls-1[data-v-4dfec2cc]{fill:#c3c7ca}.cls-2[data-v-4dfec2cc]{fill:#a4161a}.cls-3[data-v-4dfec2cc]{fill:#ffae03}.cls-4[data-v-4dfec2cc]{fill:#e9190f}.cls-5[data-v-4dfec2cc]{fill:#3d3c4b}.cls-6[data-v-4dfec2cc]{fill:#fff}.cls-7[data-v-4dfec2cc]{fill:#6ab6d1}.cls-8[data-v-4dfec2cc]{fill:none;stroke:#b0b0af;stroke-miterlimit:10;stroke-width:.75px}.cls-9[data-v-4dfec2cc]{fill:#bebec5}.cls-10[data-v-4dfec2cc]{font-size:22px;font-family:Comfortaa-Regular,Comfortaa}.cls-11[data-v-4dfec2cc],.cls-12[data-v-4dfec2cc]{letter-spacing:-.03em}", ""]);

// exports
